export const frequencyUnits = ["Days", "Weeks", "Months"];
export const weekDays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
export const faxStatusList = [
  "DRAFT",
  "SENDING",
  "SUCCESS",
  "COMPLETED",
  "FAILED",
  "SENT TO 1 OF 2 RECIPIENTS",
  "SENT TO 0 OF 2 RECIPIENTS",
];
export const faxStatusColors = {
  DRAFT: "grey--text",
  SENDING: "black--text",
  COMPLETED: "green--text",
  SUCCESS: "green--text",
  FAILED: "red--text",
  "SENT TO 1 OF 2 RECIPIENTS": "orange--text",
  "SENT TO 0 OF 2 RECIPIENTS": "orange--text",
};
